import { MEDEWERKERS_OP_STATION_VOS_QUERY_KEY } from "@/entities/medewerkers-op-station/constants";
import { useUnauthenticatedApiClient } from "@/infrastructure/rest";
import { VosOproepDto, VosOproepReactieDto } from "@/shared/types";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

type PostVosResponse = VosOproepReactieDto & {
    token: string;
};

export function usePostVosResponse() {
    const queryClient = useQueryClient();
    const apiClient = useUnauthenticatedApiClient();

    return useMutation({
        mutationFn: async ({ token, gaatKomen }: PostVosResponse) => {
            await apiClient.post(`/public/vos-oproep/${token}/reactie`, { gaatKomen });
        },
        onSuccess: async (_, variables) => {
            await queryClient.invalidateQueries({
                queryKey: [MEDEWERKERS_OP_STATION_VOS_QUERY_KEY, variables.token],
            });
        },
        onError: (error, variables) => {
            console.error(`Fout bij het opslaan van VOS antwoord met token [${variables.token}]`, error);
        },
    });
}

export function useGetVosOproep(token: string) {
    const apiClient = useUnauthenticatedApiClient();

    return useQuery({
        queryKey: [MEDEWERKERS_OP_STATION_VOS_QUERY_KEY, token],
        queryFn: async () => {
            return await apiClient.get<VosOproepDto>(`/public/vos-oproep/${token}`);
        },
        /* Don't retry, so we immediately show the error state, otherwise we retry 3 times first */
        retry: false,
    });
}
